import ColumnOrder from '../ColumnOrder/ColumnOrder';
import ExportToExcel from '../Export/ExportToExcel';
import ExportToPDF from '../Export/ExportToPDF';
import CustomFilter from './CustomFilter';

const DesktopFilters: React.FC = () => {
  return (
    <>
      <CustomFilter />
      <ColumnOrder />
      <ExportToExcel />
      <ExportToPDF />
    </>
  );
};
export default DesktopFilters;
